import { t } from "../../../../i18n";
import { useState } from 'react';
import { useTheme } from '@mui/material/styles';
import { Box, Button, FormControl, FormHelperText, IconButton, InputAdornment, InputLabel, OutlinedInput, Stack, Typography } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useLocation, useNavigate } from 'react-router-dom';
import AnimateButton from '../../../../component/extended/AnimateButton';
import { useForgetPasswordSubmit } from 'hooks/useAuth';

// ============================|| FIREBASE - LOGIN ||============================ //

function AuthForgetPasswordSubmit({
  ...others
}) {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const formikSignIn = useForgetPasswordSubmit(location?.state?.email);
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };
  const handleMouseDownPassword = event => {
    event.preventDefault();
  };
  return <form noValidate onSubmit={formikSignIn.handleSubmit} {...others}>
            <FormControl fullWidth error={Boolean(formikSignIn.touched.validationCode && formikSignIn.errors.validationCode)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-validationcode">{t("Código de Validação")}</InputLabel>
                <OutlinedInput id="outlined-adornment-validationcode" type="text" value={formikSignIn.values.validationCode} name="validationCode" onBlur={formikSignIn.handleBlur} onChange={formikSignIn.handleChange} label={t("Validation Code")} inputProps={{}} />
                {formikSignIn.touched.validationCode && t(formikSignIn.errors.validationCode) && <FormHelperText error id="standard-weight-helper-text-validationcode">
                            {t(formikSignIn.errors.validationCode)}
                        </FormHelperText>}
            </FormControl>

            <FormControl fullWidth error={Boolean(formikSignIn.touched.newPassword && formikSignIn.errors.newPassword)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-new-password">{t("Nova Password")}</InputLabel>
                <OutlinedInput id="outlined-adornment-new-password" type={showPassword ? 'text' : 'password'} value={formikSignIn.values.newPassword} name="newPassword" onBlur={formikSignIn.handleBlur} onChange={formikSignIn.handleChange} endAdornment={<InputAdornment position="end">
                            <IconButton aria-label={t("toggle password visibility")} onClick={handleClickShowPassword} onMouseDown={handleMouseDownPassword} edge="end" size="large">
                                {showPassword ? <Visibility /> : <VisibilityOff />}
                            </IconButton>
                        </InputAdornment>} label={t("Nova Password")} inputProps={{}} />
                {formikSignIn.touched.newPassword && t(formikSignIn.errors.newPassword) && <FormHelperText error id="standard-weight-helper-text-password-login">
                        {t(formikSignIn.errors.newPassword)}
                    </FormHelperText>}
            </FormControl>
            <FormControl fullWidth error={Boolean(formikSignIn.touched.newPassword && formikSignIn.errors.confirmPassword)} sx={{
      ...theme.typography.customInput
    }}>
                <InputLabel htmlFor="outlined-adornment-confirm-password">{t("Confirmar Password")}</InputLabel>
                <OutlinedInput id="outlined-adornment-confirm-password" type={showPassword ? 'text' : 'password'} value={formikSignIn.values.confirmPassword} name="confirmPassword" onBlur={formikSignIn.handleBlur} onChange={formikSignIn.handleChange} label={t("Confirmar Password")} inputProps={{}} />
                {formikSignIn.touched.newPassword && t(formikSignIn.errors.confirmPassword) && <FormHelperText error id="standard-weight-helper-text-password-confirm">
                            {t(formikSignIn.errors.confirmPassword)}
                        </FormHelperText>}
            </FormControl>
            <Stack direction="row" justifyContent="start" spacing={1}>
                <Typography variant="subtitle1" color="accent.main" sx={{
        textDecoration: 'none',
        cursor: 'pointer'
      }} component="a" onClick={() => navigate('/login', {
        replace: true
      })}>{t("Voltar a início de sessão")}</Typography>
            </Stack>
            {t(formikSignIn.errors.submit) && <Box sx={{
      mt: 3
    }}>
                    <FormHelperText error>{t(formikSignIn.errors.submit)}</FormHelperText>
                </Box>}

            <Box sx={{
      mt: 2
    }}>
                <AnimateButton>
                    <Button disableElevation disabled={formikSignIn.isSubmitting} fullWidth size="large" type="submit" variant="contained" color="secondary" name="submit">{t("Alterar Password")}</Button>
                </AnimateButton>
            </Box>
        </form>;
}
export default AuthForgetPasswordSubmit;
